// eslint-disable-next-line iventis/filenames
import { AppDetails } from "@iventis/components";
import { ApplicationName } from "@iventis/domain-model/model/applicationName";

export const applicationDetails: AppDetails[] = [
    {
        icon: "fire",
        appName: "TorchDashboard",
        url: "torch-dashboard",
        displayName: "Dashboard",
    },
    {
        icon: "person-running",
        appName: "TorchBearers",
        url: "torch-bearers",
        displayName: "Torch Bearers",
    },
    {
        icon: "map",
        appName: ApplicationName.Maps.toString(),
        url: "spatial-planner",
    },
    {
        icon: "users",
        appName: ApplicationName.People.toString(),
        url: "people",
    },
    {
        icon: "gear",
        appName: ApplicationName.Settings.toString(),
        url: "project-settings",
    },
];
